module.exports = __webpack_public_path__ + "img/american-credit-prequalify-promptly-960w.66c525f.jpg";